export { type LinkProps, default as Link } from './Link';
